import Tab from "components/Tab";
import Web from "../../../../contents/docs/session-replay/_snippets/web-installation.mdx";
import ReactNative from "../../../../contents/docs/session-replay/_snippets/react-native-installation.mdx";
import Android from "../../../../contents/docs/session-replay/_snippets/android-installation.mdx";
import IOS from "../../../../contents/docs/session-replay/_snippets/ios-installation.mdx";
import Flutter from "../../../../contents/docs/session-replay/_snippets/flutter-installation.mdx";
import * as React from 'react';
export default {
  Tab,
  Web,
  ReactNative,
  Android,
  IOS,
  Flutter,
  React
};